document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.header-wrapper');
  var hero = document.querySelector('[data-hero]');
  if (!header || !hero) {
    return;
  }

  document.body.classList.add('has-hero');

  function toggleHeader() {
    var heroBottom = hero.getBoundingClientRect().bottom; 
       
    if (heroBottom <= 80) {
      header.classList.add('is-scrolled');
    } else {      
      header.classList.remove('is-scrolled');
    }
  }

  toggleHeader();
  window.addEventListener('scroll', toggleHeader, { passive: true });
});

// ── Sync compteur panier custom après toute modification du cart-drawer ──
(function () {
  function syncCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        var display = count < 10 ? '0' + count : String(count);
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = display;
        });
      });
  }

  // Observe les changements dans le cart-drawer (ajout, suppression, quantité)
  function observeCartDrawer() {
    var cartItems = document.querySelector('#CartDrawer-CartItems');
    if (!cartItems) return;

    var observer = new MutationObserver(function () {
      syncCartCount();
    });

    observer.observe(cartItems, { childList: true, subtree: true });
  }

  // Démarre l'observation une fois le DOM prêt
  document.addEventListener('DOMContentLoaded', function () {
    observeCartDrawer();

    // Si le cart-drawer est injecté dynamiquement, réessaie après un délai
    setTimeout(observeCartDrawer, 1500);
  });
})();
